module.exports = __webpack_public_path__ + "static/media/chat_notify.150350e7.svg";